<template>
  <div class="row">
    <div class="col-12">
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div class="whats-news-caption">
            <div class="row">
              <div v-for="item in data" :key="item.id" class="col-lg-6 col-md-6 col-sm-12">
                <news-notify-auction-item :data="item" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsNotifyAuctionItem from './NewsNotifyAuctionItem.vue';
export default {
  name: 'NewsNotifyAuctionList',
  components: { NewsNotifyAuctionItem },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/NewsNotifyAuctionList.vue